module.exports = "<div class=\"flex-column justify-center items-center text-center full-vh\">\n\t<img class=\"logo-small mbm\" src=\"./assets/img/logo.svg\" width=\"100\">\n\t<form id=\"form-login\">\n\t\t<p class=\"error-msg mbs\" *ngIf=\"errors.code\">{{errors.code}}</p>\n    <a\n      [href]=\"azureUrl\"\n      class=\"btn btn-lg btn-secondary uppercase btn-block mtl mvs\"\n    >Me connecter</a>\n\t</form>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.html
// module id = ./src/app/login/login.component.html
// module chunks = main